<kendo-dialog class="{{type}}" *ngIf="opened"
              [title]="title"
              [width]="width"
              [height]="'80%'"
              (close)="onClose()"
>
    <ul class="listitem">
        <li (click)="close(store)" *ngFor="let store of categories" class="la pointer">
            {{store.identity}}
        </li>
    </ul>
</kendo-dialog>
<div kendoDialogContainer></div>
